var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { FileStateType } from '../../../../defs/schema-static';
import { FileDownloaderService } from '../shared/file-downloader/file-downloader.service';
import { FileManagerService } from '../shared/file-manager/file-manager.service';
var FileManagerComponent = (function () {
    function FileManagerComponent(fileManager, changeDetectorRef, fileDownloader) {
        this.fileManager = fileManager;
        this.changeDetectorRef = changeDetectorRef;
        this.fileDownloader = fileDownloader;
        this.reduced = false;
        this.minimized = true;
        this.getFilename = FileManagerService.getFilename;
        this.FileStateType = FileStateType;
        this.downloadS3 = this.fileDownloader.downloadS3.bind(this.fileDownloader);
    }
    FileManagerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.uploadingFileStateSubscription = this.fileManager.uploadingFileState.subscribe(function () {
            _this.changeDetectorRef.detectChanges();
        });
    };
    FileManagerComponent.prototype.ngOnDestroy = function () {
        if (this.uploadingFileStateSubscription) {
            this.uploadingFileStateSubscription.unsubscribe();
            this.uploadingFileStateSubscription = undefined;
        }
    };
    FileManagerComponent.prototype.reduce = function () {
        this.reduced = true;
        this.minimized = false;
    };
    FileManagerComponent.prototype.maximize = function () {
        this.minimized = this.reduced = false;
    };
    Object.defineProperty(FileManagerComponent.prototype, "files", {
        get: function () {
            return this.fileManager.uploadingFiles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileManagerComponent.prototype, "filesRunning", {
        get: function () {
            return this.fileManager.uploadingFilesRunning;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileManagerComponent.prototype, "filesOver", {
        get: function () {
            return this.fileManager.uploadingFilesOver;
        },
        enumerable: true,
        configurable: true
    });
    FileManagerComponent.prototype.getFilesState = function () {
        var states = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            states[_i] = arguments[_i];
        }
        return this.files.filter(function (file) { return states.includes(file.state); });
    };
    FileManagerComponent.prototype.clear = function () {
        this.fileManager.clearFilesOver();
    };
    FileManagerComponent.prototype.cancelAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                return [2, (_a = this.fileManager).cancelFiles.apply(_a, this.filesRunning)];
            });
        });
    };
    FileManagerComponent.prototype.pauseAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                return [2, (_a = this.fileManager).pauseFiles.apply(_a, this.filesRunning)];
            });
        });
    };
    FileManagerComponent.prototype.resumeAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                return [2, (_a = this.fileManager).resumeFiles.apply(_a, this.filesRunning)];
            });
        });
    };
    Object.defineProperty(FileManagerComponent.prototype, "visible", {
        get: function () {
            return this.files.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileManagerComponent.prototype, "averageProgress", {
        get: function () {
            return (this.filesRunning.reduce(function (sum, file) {
                return sum +
                    Number(file.transferStats && (file.transferStats.totalUploaded || file.transferStats.loaded)) ||
                    0;
            }, 0) / this.filesRunning.reduce(function (sum, file) { return sum + file.size || 0; }, 0) || 1);
        },
        enumerable: true,
        configurable: true
    });
    FileManagerComponent.prototype.confirmUnloadChanges = function ($event) {
        if (this.filesRunning.length > 0) {
            $event.preventDefault();
            return ($event.returnValue = true);
        }
    };
    return FileManagerComponent;
}());
export { FileManagerComponent };
